import { useEffect, useState } from "react";
import { authAPI } from "@/lib/api";
import { useSearchParams, Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";

export default function VerifyEmailFromLink() {
  const [params] = useSearchParams();
  const [status, setStatus] = useState("verifying");
  const [message, setMessage] = useState("");

  useEffect(() => {
    const token = params.get("token");
    if (!token) { setStatus("error"); setMessage("Missing token"); return; }
    authAPI.verifyEmail({ token })
      .then((r) => {
        setStatus("ok");
        setMessage(r.data?.already_verified ? "Your email was already verified." : "Email verified. Welcome to SRC.");
      })
      .catch((err) => {
        setStatus("error");
        setMessage(err.response?.data?.detail || "Verification failed");
      });
  }, [params]);

  return (
    <div className="mx-auto flex min-h-[60vh] max-w-lg flex-col items-center justify-center gap-4 px-6 text-center">
      {status === "verifying" && (<>
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
        <p className="font-display text-lg font-bold uppercase">Verifying your email…</p>
      </>)}
      {status === "ok" && (<>
        <CheckCircle2 className="h-10 w-10 text-emerald-400" />
        <h1 className="font-display text-2xl font-bold uppercase">Email verified</h1>
        <p className="text-sm text-muted-foreground">{message}</p>
        <Link to="/login"><Button className="bg-primary text-primary-foreground hover:bg-primary/90">Sign in</Button></Link>
      </>)}
      {status === "error" && (<>
        <XCircle className="h-10 w-10 text-primary" />
        <h1 className="font-display text-2xl font-bold uppercase">Couldn&apos;t verify</h1>
        <p className="text-sm text-muted-foreground">{message}</p>
        <Link to="/login"><Button variant="outline">Back to sign in</Button></Link>
      </>)}
    </div>
  );
}
